import { ChevronRightIcon } from '@langchain/untitled-ui-icons';

import { Text } from '@/design-system';
import { cn } from '@/utils/tailwind';

import { TreeNode } from '../types';

export const NameDisplay = ({
  node,
  isExpanded,
  setExpandedIds,
}: {
  node: TreeNode;
  isExpanded: boolean;
  setExpandedIds: React.Dispatch<React.SetStateAction<Set<string>>>;
}) => {
  const paddingLeft =
    (node.depth == 0 && node.isLeaf ? 36 : node.depth * 36) + 'px'; // 36px per level of depth
  const hasChildren = !node.isLeaf && node.children && node.children.length > 0;

  return (
    <div className={'flex items-center gap-2'} style={{ paddingLeft }}>
      {hasChildren && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setExpandedIds((prev) => {
              const newSet = new Set(prev);
              if (newSet.has(node.id)) {
                newSet.delete(node.id);
              } else {
                newSet.add(node.id);
              }
              return newSet;
            });
          }}
          className="flex h-5 w-5 items-center justify-center rounded hover:bg-secondary"
          aria-label={isExpanded ? 'Collapse' : 'Expand'}
        >
          <Text variant="xs" color="tertiary">
            <ChevronRightIcon
              className={cn(
                isExpanded ? 'rotate-90' : '',
                'h-4 w-4 transition-transform'
              )}
            />
          </Text>
        </button>
      )}
      <Text
        variant="sm"
        weight={node.depth === 0 ? 'semibold' : 'medium'}
        color={node.depth === 0 ? 'tertiary' : 'secondary'}
      >
        {node.name}
      </Text>
    </div>
  );
};
